let noFlyZones = null;
let notams = null;
let rocketNotams = null

async function fetchNoFlyZones()
{
	let response = await fetch('/api/tools/no-fly-zones', {
	})

	noFlyZones = await response.json()

	for(let i = 0; i < noFlyZones.length; i++)
	{
		let zone = noFlyZones[i];
		zone.path = zone.path.map(e => ({ lat: e[1], lng: e[0]}))
	}
}

export const getNoFlyZones = async function()
{
	if(!noFlyZones)
		await fetchNoFlyZones();

	return noFlyZones;
}



let clubs = [
	{ 
		name: 'Midland Rocketry Club',
		url: 'https://www.midlandrocketry.org.uk/',
		center: { lat: 52.6688015, lng: -1.5247266 }
	},
	{
		name: 'East Anglian Rocketry Society',
		url: 'https://ears.org.uk/',
		center: { lat: 52.2531495, lng: -0.0914776}
	},
	{
		name: 'Scottish Aeronautics and Rocketry Association',
		url: 'https://www.sara.rocketry.org.uk/',
		center: { lat: 55.7265293, lng: -4.8120324}
	}
]

async function fetchNotams()
{
	let response = await fetch('/api/tools/list-notams', {
	})

	notams = await response.json()

	for(let i = 0; i < notams.length; i++)
	{
		let notam = notams[i];
		notam.path = notam.path.map(e => ({ lat: e[1], lng: e[0]}))
	
		var x = notam.path.map(p => p.lat);
		var y = notam.path.map(p => p.lng);
		var cx = (Math.min(...x) + Math.max(...x)) / 2;
		var cy = (Math.min(...y) + Math.max(...y)) / 2;
		notam.center = { lat: cx, lng: cy}
	
		notam.from = new Date(notam.from)
		notam.to = new Date(notam.to)
	
		notam.club = clubs.find(c => pointIsInPoly(c.center, notam.path));
	}

	notams.sort((a, b) => a.from.getTime() - b.from.getTime())

	rocketNotams = notams.filter(n => n.name.toLowerCase().indexOf('rocket') > -1)
}

export const getNotams = async function()
{
	if(!notams)
		await fetchNotams();

	return notams;
}

export const getRocketNotams = async function()
{
	if(!notams)
		await fetchNotams();

	return rocketNotams;
}


export const pointIsInPoly = function(p, polygon) {
    var isInside = false;
    var minX = polygon[0].lng, maxX = polygon[0].lng;
    var minY = polygon[0].lat, maxY = polygon[0].lat;
    for (var n = 1; n < polygon.length; n++) {
        var q = polygon[n];
        minX = Math.min(q.lng, minX);
        maxX = Math.max(q.lng, maxX);
        minY = Math.min(q.lat, minY);
        maxY = Math.max(q.lat, maxY);
    }

    if (p.lng < minX || p.lng > maxX || p.lat < minY || p.lat > maxY) {
        return false;
    }

    var i = 0, j = polygon.length - 1;
    for (i, j; i < polygon.length; j = i++) {
        if ( (polygon[i].lat > p.lat) != (polygon[j].lat > p.lat) &&
                p.lng < (polygon[j].lng - polygon[i].lng) * (p.lat - polygon[i].lat) / (polygon[j].lat - polygon[i].lat) + polygon[i].lng ) {
            isInside = !isInside;
        }
    }

    return isInside;
}